import React from "react";
import { Layout } from "../components/Layout";
import Project from "../components/Project";

const ProjectsPage = () => {
  return (
    <Layout>
      <Project />
    </Layout>
  );
};

export default ProjectsPage;
